import { render, staticRenderFns } from "./EspecieEmailForm.vue?vue&type=template&id=2c50cacb&"
import script from "./EspecieEmailForm.vue?vue&type=script&lang=js&"
export * from "./EspecieEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports